
import store from "../store/index"
import {
  isString
} from './validsUtils'


/**
 * 标签级别的权限校验
 * @param value 前端配置的权限，如['kernal:orgtab:prevorgplay']
 * @returns {boolean}
 */
export default function checkPermission(value) {

  if (!value) {
    return false
  }
  const permissions = store.getters && store.getters.permissions
  if (value instanceof Array && value.length > 0) {
    const flag = value.some((permission)=>{
        return permissions.some(item=>item.code == permission);
    })
    return flag;
  }
  // value是字符串
  if (isString(value)) {
    return permissions.some(item=>item.code == value);
  }
  return false
}


/**
 * 过滤省级管理用户
 * @param menu 后台返回的菜单列表
 * @returns {boolean}
 */

export function filterProvinceManage(menu){

  let flag = menu.some((item,index)=>{
    if(item.code == "user"){
      return item.children.some(i => i.code == "manager");
    }
  })
  return flag;

}


/**
 * 过滤按钮权限
 * @param value 前端配置的权限，如['ProvinceBatchSubModel|Province|addbtn']
 * @returns {boolean}
 */
export  function checkPermissionBtn(value){
  // const userInfo= JSON.parse(sessionStorage.getItem("unInfo"));
  // if(userInfo.user.monitor == 1){
  // }
  // else{
  //   return false
  // }
        if (!value) {
          return false
        }
        const permissions = store.getters && store.getters.BtnPermissionData
        if (value instanceof Array && value.length > 0) {
          const flag = value.some((permission)=>{
            return permissions.some(item=>item.code == permission);
          })
          return flag;
        }
        // value是字符串
        if (isString(value)) {
          return permissions.some(item=>item.code == value);
        }
        return false



}


/**
 * 标签级别不同名称展示
 * @param value 前端配置的权限，如['kernal:orgtab:prevorgplay']
 * @returns {String}
 */

export  function checkPermissionName(value) {
  if (!value) {
    return ""
  }
  const permissionsTabObj = store.getters && store.getters.permissionsTabName
  if (value instanceof Array && value.length > 0) {
    let title = "";
    value.forEach((item,index)=>{
         title =permissionsTabObj[item]
    });
    return title;
  }
  // value是字符串
  if (isString(value)) {
    return permissionsTabObj[value];
  }

  return "";
}







// WEBPACK FOOTER //
// ./src/plugins/checkpermission.js